import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Breadcrumbs from '../components/shared/Breadcrumbs';

const RatgeberPage = () => {
  const categories = [
    {
      title: 'LLC USA',
      guides: [
        { href: '/ratgeber/llc-wyoming-gruenden', title: 'LLC in Wyoming gründen — Der ultimative Leitfaden 2026' },
        { href: '/ratgeber/llc-delaware-gruenden', title: 'LLC in Delaware gründen — Vorteile, Kosten & Anleitung' },
        { href: '/ratgeber/llc-florida-gruenden', title: 'LLC in Florida gründen — Leitfaden für internationale Gründer' },
        { href: '/ratgeber/llc-new-mexico-gruenden', title: 'LLC in New Mexico gründen — Maximale Anonymität' },
        { href: '/ratgeber/llc-texas-gruenden', title: 'LLC in Texas gründen — Alles was Sie wissen müssen' },
        { href: '/ratgeber/llc-fuer-amazon-fba', title: 'LLC für Amazon FBA — Brauchen Sie eine?' },
        { href: '/ratgeber/llc-freelancer-digitale-nomaden', title: 'LLC für Freelancer und Digitale Nomaden' },
        { href: '/ratgeber/llc-immobilien-usa', title: 'LLC für Immobilien-Investitionen in den USA' },
        { href: '/ratgeber/digitale-produkte-verkaufen-llc', title: 'Digitale Produkte verkaufen mit einer US-LLC' },
        { href: '/ratgeber/serie-llc-erklaert', title: 'Serie LLC — Was ist das und für wen lohnt sie sich?' },
      ]
    },
    {
      title: 'Steuern & Finanzen',
      guides: [
        { href: '/ratgeber/ein-nummer-beantragen', title: 'EIN Nummer beantragen — Schritt-für-Schritt Anleitung' },
        { href: '/ratgeber/llc-steuern-deutsche', title: 'LLC Steuern für Deutsche — Was Sie wissen müssen' },
        { href: '/ratgeber/us-bankkonto-eroeffnen-auslaender', title: 'US-Bankkonto eröffnen als Ausländer — Der komplette Guide' },
        { href: '/ratgeber/itin-beantragen-anleitung', title: 'ITIN beantragen — Anleitung für nicht-US-Bürger' },
        { href: '/ratgeber/llc-kosten-ueberblick', title: 'Was kostet eine LLC? — Alle Kosten im Überblick 2026' },
      ]
    },
    {
      title: 'Rechtliches & Compliance',
      guides: [
        { href: '/ratgeber/operating-agreement-llc', title: 'Operating Agreement für Ihre LLC — Warum es unverzichtbar ist' },
        { href: '/ratgeber/annual-report-llc', title: 'Jahresbericht (Annual Report) für Ihre LLC — Was Sie beachten müssen' },
        { href: '/ratgeber/registered-agent-wechseln', title: 'Registered Agent wechseln — So geht\'s einfach' },
        { href: '/ratgeber/llc-aufloesen', title: 'LLC auflösen — Schritt-für-Schritt Anleitung' },
        { href: '/ratgeber/virtual-office-llc', title: 'Virtual Office für Ihre LLC — Brauchen Sie eins?' },
      ]
    },
    {
      title: 'Vergleiche',
      guides: [
        { href: '/ratgeber/beste-llc-gruendungsservices-vergleich', title: 'Die 5 besten LLC-Gründungsservices 2026 im Vergleich' },
        { href: '/ratgeber/llc-vs-gmbh-vergleich', title: 'LLC vs. GmbH — Vergleich für deutsche Unternehmer' },
      ]
    },
    {
      title: 'UK & Kanada',
      guides: [
        { href: '/ratgeber/ltd-england-vs-schottland', title: 'LTD gründen: England vs. Schottland — Unterschiede erklärt' },
        { href: '/ratgeber/firmenkonto-uk-eroeffnen', title: 'Firmenkonto in Großbritannien eröffnen — Guide für Ausländer' },
        { href: '/ratgeber/corporation-ontario-gruenden', title: 'Corporation in Ontario gründen — Schritt für Schritt' },
      ]
    },
  ];

  return (
    <div className="py-12" data-testid="ratgeber-page">
      <div className="container-wide">
        <Breadcrumbs items={[{ label: 'Ratgeber', href: '/ratgeber' }]} />

        <header className="mb-12">
          <h1 className="mb-6">Ratgeber & Guides</h1>
          <p className="text-xl text-slate-600 max-w-3xl">
            Umfassende Anleitungen zur Firmengründung im Ausland. Von der LLC in den USA 
            bis zur LTD in UK — alle wichtigen Informationen für deutschsprachige Unternehmer.
          </p>
        </header>

        <div className="space-y-16">
          {categories.map((category, catIndex) => (
            <section key={catIndex}>
              <h2 className="text-2xl font-heading font-bold text-navy-900 mb-6 pb-4 border-b border-slate-200">
                {category.title}
              </h2>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {category.guides.map((guide, guideIndex) => (
                  <Link
                    key={guideIndex}
                    to={guide.href}
                    className="group card-flat p-6 hover:shadow-sm"
                    data-testid={`guide-link-${catIndex}-${guideIndex}`}
                  >
                    <h3 className="font-heading font-semibold text-navy-900 mb-3 group-hover:text-teal-600 transition-colors">
                      {guide.title}
                    </h3>
                    <span className="inline-flex items-center gap-1 text-teal-600 text-sm font-medium group-hover:gap-2 transition-all">
                      Jetzt lesen
                      <ArrowRight className="w-4 h-4" />
                    </span>
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>

        {/* Featured Guides Section */}
        <section className="mt-20 py-12 bg-slate-50 -mx-4 sm:-mx-6 lg:-mx-8 px-4 sm:px-6 lg:px-8 rounded-sm">
          <h2 className="text-2xl font-heading font-bold text-navy-900 mb-8 text-center">
            Unsere beliebtesten Ratgeber
          </h2>
          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <Link to="/llc-usa-gruenden" className="group text-center">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-white border border-slate-200 rounded-sm group-hover:border-teal-300 transition-colors">
                <span className="text-3xl">🇺🇸</span>
              </div>
              <h3 className="font-heading font-bold text-navy-900 group-hover:text-teal-600 transition-colors">
                LLC Gründung USA
              </h3>
              <p className="text-sm text-slate-600 mt-2">
                Der komplette Leitfaden
              </p>
            </Link>
            
            <Link to="/northwest-registered-agent-erfahrungen" className="group text-center">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-white border border-slate-200 rounded-sm group-hover:border-teal-300 transition-colors">
                <span className="text-3xl">⭐</span>
              </div>
              <h3 className="font-heading font-bold text-navy-900 group-hover:text-teal-600 transition-colors">
                Northwest Testbericht
              </h3>
              <p className="text-sm text-slate-600 mt-2">
                Unser #1 Testsieger
              </p>
            </Link>
            
            <Link to="/registered-agent" className="group text-center">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-white border border-slate-200 rounded-sm group-hover:border-teal-300 transition-colors">
                <span className="text-3xl">📋</span>
              </div>
              <h3 className="font-heading font-bold text-navy-900 group-hover:text-teal-600 transition-colors">
                Registered Agent
              </h3>
              <p className="text-sm text-slate-600 mt-2">
                Was ist das?
              </p>
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default RatgeberPage;
